import {transactionRoutingService} from "../../common/api.service";

const initialStates = {
    setting_status: 'loading',
    statistics_status: 'loading',
    setting: {},
    psp_list: {},
    statistics: {},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
        state.setting = {}
    },
    successSetting(state, setting) {
        state.setting_status = 'success';
        state.setting = setting
    },
    successStatistics(state, statistics) {
        state.statistics_status = 'success';
        state.statistics = statistics
    },
    pspList(state, data) {
        state.psp_list = data
    },
}

const getters = {
    setting_status: ({setting_status}) => setting_status,
    setting: ({setting}) => setting,
    psp_list: ({psp_list}) => psp_list,
    statistics: ({statistics}) => statistics,
    statistics_status: ({statistics_status}) => statistics_status,
}

const actions = {
    fetchSetting({commit}) {
        commit('loading')
        return transactionRoutingService.fetchCoreSetting()
            .then(response => {
                commit('successSetting', response.data.data.setting)
                commit('pspList', response.data.data.psp_list)
            })
    },
    fetchStarshopSetting({commit}) {
        commit('loading')
        return transactionRoutingService.fetchStarshopSetting()
            .then(response => {
                commit('successSetting', response.data.data.setting)
                commit('pspList', response.data.data.psp_list)
            })
    },
    fetchCoreStatistics({commit}) {
        commit('loading')
        return transactionRoutingService.fetchCoreStatistics()
            .then(response => {
                commit('successStatistics', response.data)
            })
    },
    fetchStarshopStatistics({commit}) {
        commit('loading')
        return transactionRoutingService.fetchStarshopStatistics()
            .then(response => {
                commit('successStatistics', response.data)
            })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}